/**
 * Scroll container utilities.
 *
 * Since PR #132 the scroll container is .app-main (overflow-y: auto),
 * NOT window. These helpers centralise the lookup so every consumer stays in sync.
 */

/** Return the scroll container element (.app-main) or window as fallback. */
export const getScrollContainer = () =>
  document.querySelector('.app-main') || window;

/** Return the current vertical scroll position of the scroll container. */
export const getScrollTop = (container) => {
  const el = container ?? getScrollContainer();
  return el === window ? window.scrollY : el.scrollTop;
};

/** Return the total scrollable height of the scroll container. */
export const getScrollHeight = (container) => {
  const el = container ?? getScrollContainer();
  return el === window
    ? document.documentElement.scrollHeight
    : el.scrollHeight;
};
